module.exports = __webpack_public_path__ + "media/bg.3f178399.mp3";